import axios from 'axios';
import config from '../config';
import handleServiceResponse from '../hof/handleServiceResponse';

export class Wallet {
    static getSbdHistory = async () => {

        return await handleServiceResponse(async () => {

            const options = {
                url: config.API_ADDR + '/coins/hbd',
                method: 'GET',
            };
            const { data } = await axios(options)
            return data;
        })

    }

    static claimRewards = async (username) => {

        return await handleServiceResponse(async () => {

            const options = {
                url: config.API_ADDR + '/account/rewards/claim',
                method: 'POST',
                data: {
                    username: username
                }
            };
            const { data } = await axios(options)
            return data;
        })

    }
}
